/* eslint-disable jsx-a11y/anchor-is-valid */
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import Text from "../../components/Text";
import { Img } from "components";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { PATH } from "utils";

export default function Footer({ marginTop }: { marginTop?: string }) {
    return (
        <footer className={classNames("bg-[#4949DE] text-[white] mt-4", marginTop)}>
            {/* Main Footer Content */}
            <div className="max-w-7xl mx-auto px-6 py-12">
                <div className="grid grid-cols-4 md:grid-cols-1 gap-8 mb-12">
                    {/* Logo and Social Section */}
                    <div className="flex flex-col justify-start gap-4">
                        <Img
                            alt={"asdansjdbasdnasbd"}
                            src={`images/new-landing-page/whiteLogo.png`}
                            className="object-cover w-[50%]"
                            enableShimmer={false}
                        />

                        {/* Social Icons */}
                        <div className="flex gap-4 mb-6">
                            <a href="#" className="hover:text-blue-200 transition">
                                <Facebook size={20} />
                            </a>
                            <a href="#" className="hover:text-blue-200 transition">
                                <Instagram size={20} />
                            </a>
                            <a href="#" className="hover:text-blue-200 transition">
                                <Linkedin size={20} />
                            </a>
                            <a href="#" className="hover:text-blue-200 transition">
                                <Youtube size={20} />
                            </a>
                        </div>

                        {/* Download App */}
                        <div>
                            <p className="text-sm font-medium mb-3">Download our App</p>
                            <div className="flex gap-2">
                                <Img
                                    alt={"asdansjdbasdnasbsd"}
                                    src={`images/new-landing-page/downloadGooglePlay.png`}
                                    className="object-cover w-[40%]"
                                    enableShimmer={false}
                                />
                                <Img
                                    alt={"asdansjdbasdnasbwd"}
                                    src={`images/new-landing-page/downloadAppStore.png`}
                                    className="object-cover w-[40%]"
                                    enableShimmer={false}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Links Section */}
                    <div>
                        <Text
                            label="Links"
                            type="description"
                            cName="text-[white] font-semibold text-base mb-4 block"
                        />
                        <ul className="space-y-2">
                            <li><Link to={PATH.PATH_FOR_ABOUT_US} className="text-blue-100 hover:text-[white] transition text-sm">About Us</Link></li>
                            <li><Link to={PATH.PATH_FOR_CONTACT_US} className="text-blue-100 hover:text-[white] transition text-sm">Contact Us</Link></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">Blogs</a></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">Press</a></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">Use cases</a></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">For Startups</a></li>
                        </ul>
                    </div>

                    {/* Your AI Employees Section */}
                    <div>
                        <Text
                            label="Your AI Employees"
                            type="description"
                            cName="text-[white] font-semibold text-base mb-4 block"
                        />
                        <ul className="space-y-2">
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI Marketing</a></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI Teaching</a></li>
                            {/* <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI for Startups</a></li> */}
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI Support</a></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI Operations</a></li>
                        </ul>
                    </div>

                    {/* Add Ons Section */}
                    <div>
                        <Text
                            label="Add Ons"
                            type="description"
                            cName="text-[white] font-semibold text-base mb-4 block"
                        />
                        <ul className="space-y-2">
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI Powered WhatsApp</a></li>
                            <li><a href="#" className="text-blue-100 hover:text-[white] transition text-sm">AI Powered ID Cards/QR Code</a></li>
                        </ul>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-blue-400 opacity-30 mb-6"></div>

                {/* Bottom Footer */}
                <div className="flex md:flex-col md:gap-2 justify-between items-center text-xs text-blue-100">
                    <p>Copyright 2025 Soomuch.AI . All rights reserved</p>
                    <div className="flex md:flex-wrap md:justify-center gap-6 md:mt-4">
                        <a href="/refund-policy" className="hover:text-[white] transition">Return & Refund Policy</a>
                        <a href="/privacy-policy" className="hover:text-[white] transition">Privacy Policy</a>
                        <a href="/terms-of-service" className="hover:text-[white] transition">Terms of Service</a>
                        <a href="/privacy-policy" className="hover:text-[white] transition">Cookie Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}